import { axiosHttp } from "@/utils/http"
import { TemplateDataModel } from "../TemplateDataModel"


interface QuickBiReportTemplateParams{
  template_code: string,
  source?: 'indicator',
  report:  string // ReportType
}


export const serviceQuickBiReportTemplate = (params:QuickBiReportTemplateParams)=>{
  let query = new URLSearchParams(Object.entries(params)).toString()
  return axiosHttp.get<'',AxiosHttpPromise<TemplateDataModel>>(`/Manager/Report/quickBiReportTemplate?${query}`)
}